import React from 'react'
import Swal from 'sweetalert2';
import { Link } from "react-router-dom";
import authAxios from "../../services/Token";
import { currencyFormat } from '../../js/Functions';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowRight, faAt, faCalendarAlt, faCalendarCheck, faDollarSign, faEdit, faHashtag, faPercentage, faTimes } from '@fortawesome/free-solid-svg-icons';

class Editar extends React.Component {
    constructor(props) {
        super(props);
    }
    state = {
        load: '',
        datosCargados: false,
        id_departamento: '',
        id_municipio: '',
        periodo_acta: '',
        periodo_liquidacion: '',
        valor_facturado: '',
        valor_recaudo: '',
        costo_energia: '',
        otras_deducciones: '',
        traslado_neto: '',
        actaInterventoria: [],
        periodosActa: [],
        periodosLiquidacion: [],
        departamentosActa: [],
        municipiosActa: [],
        periodosActa: [],
        periodosLiquidacion: [],
        aportesFacturaActa: [],
        municipioFacturaActa: [],
        comerFacturaActa: [],
        concesionFacturaActa: [],
        errores: []
    }
    cambioValor = (e) => {
        const state = this.state.actaInterventoria;
        state[e.target.name] = e.target.value;
        this.setState({ actaInterventoria: state });
    };
    verificarError(elemento) {
        return this.state.errores.indexOf(elemento) !== -1;
    }
    enviarDatos = (e) => {
        e.preventDefault();
        const fecha_acta = document.getElementById('fecha_acta').value;
        const valor_facturado = document.getElementById('valor_facturado').value;
        const valor_recaudo = document.getElementById('valor_recaudo').value;
        const costo_energia = document.getElementById('costo_energia').value;
        const otras_deducciones = document.getElementById('otras_deducciones').value;
        const traslado_neto = document.getElementById('traslado_neto').value;
        var errores = [];
        if (!fecha_acta) { errores.push("error_fecha_acta"); }
        if (!valor_facturado) { errores.push("error_valor_facturado"); }
        if (!valor_recaudo) { errores.push("error_valor_recaudo"); }
        if (!costo_energia) { errores.push("error_costo_energia"); }
        if (!otras_deducciones) { errores.push("error_otras_deducciones"); }
        if (!traslado_neto) { errores.push("error_traslado_neto"); }
        this.setState({ errores: errores });
        if (errores.length > 0) {
            return false;
        }
        let form = document.getElementById('form');
        let formData = new FormData(form);
        console.log(formData);
        Swal.showLoading();
        authAxios.post("actas_interventoria/editar", formData)
            .then((datosRespuesta) => {
                console.log(datosRespuesta)
                Swal.close();
                Swal.fire(
                    'Actas Interventoría!',
                    datosRespuesta.data.msj,
                    'success'
                )
                this.props.history.push("/UpActasInterventoria/" + datosRespuesta.data.id);
            })
            .catch(console.log)
    }
    cargarMunicipios() {
        var id_departamento = document.getElementById('ID_COD_DPTO').value;
        Swal.showLoading();
        authAxios.get("municipios_visitas/buscardepartamento/" + id_departamento)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, municipiosActa: datosRespuesta.data, load: '' });
                Swal.close();
            })
            .catch(console.log);
    }
    seleccionarPeriodo = (tipoPeriodo, periodo) => {
        Swal.showLoading();
        var id_departamento = document.getElementById("ID_COD_DPTO").value;
        var id_municipio = document.getElementById("ID_COD_MPIO").value;
        switch (tipoPeriodo) {
            case 'ACTA':
                authAxios.get("actas_interventoria/fact_agentes/" + id_departamento + "/" + id_municipio + "/" + periodo)
                .then((datosRespuesta) => {
                    console.log(datosRespuesta);
                    var status = datosRespuesta.data.status;
                    if (status) {
                        Swal.close();
                        Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                        window.localStorage.clear();
                        window.location.href = '/';
                    }
                    this.setState({
                        datosCargados: true,
                        periodo_acta: periodo,
                        aportesFacturaActa: datosRespuesta.data.resultAportes,
                        municipioFacturaActa: datosRespuesta.data.resultMunicipio,
                        comerFacturaActa: datosRespuesta.data.resultComer,
                        concesionFacturaActa: datosRespuesta.data.resultConcesion,
                        load: ''
                    });
                    Swal.close();
                })
                .catch(console.log);
                break;
            case 'LIQUIDACION':
                authAxios.get("actas_interventoria/fact_operador/" + id_departamento + "/" + id_municipio + "/" + periodo)
                .then((datosRespuesta) => {
                    console.log(datosRespuesta);
                    var status = datosRespuesta.data.status;
                    if (status) {
                        Swal.close();
                        Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                        window.localStorage.clear();
                        window.location.href = '/';
                    }
                    this.setState({
                        datosCargados: true,
                        periodo_liquidacion: periodo,
                        valor_facturado: datosRespuesta.data.resultOperador.VALOR_FACTURA,
                        valor_recaudo: datosRespuesta.data.resultOperador.VALOR_RECAUDO,
                        costo_energia: datosRespuesta.data.resultOperador.COSTO_ENERGIA,
                        traslado_neto: datosRespuesta.data.resultOperador.VALOR_FAVOR,
                        load: ''
                    });
                    Swal.close();
                })
                .catch(console.log);
                break;
        }
    }
    componentDidMount() {
        Swal.showLoading();
        authAxios.get("actas_interventoria/ver/" + this.props.match.params.id)
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                this.setState({ datosCargados: true,
                                actaInterventoria: datosRespuesta.data.resultado,
                                load: '' });
                var id_departamento = datosRespuesta.data.resultado.ID_COD_DPTO;
                var id_municipio = datosRespuesta.data.resultado.ID_COD_MPIO;
                var periodo_acta = datosRespuesta.data.resultado.PERIODO_ACTA;
                var periodo_liquidacion = datosRespuesta.data.resultado.PERIODO_LIQUIDACION;
                document.getElementById("ID_COD_DPTO").value = id_departamento;
                document.getElementById("ID_COD_MPIO").value = id_municipio;
                authAxios.get("actas_interventoria/fact_agentes/" + id_departamento + "/" + id_municipio + "/" + periodo_acta)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        var status = datosRespuesta.data.status;
                        if (status) {
                            Swal.close();
                            Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                            window.localStorage.clear();
                            window.location.href = '/';
                        }
                        this.setState({
                            datosCargados: true,
                            periodo_acta: periodo_acta,
                            aportesFacturaActa: datosRespuesta.data.resultAportes,
                            municipioFacturaActa: datosRespuesta.data.resultMunicipio,
                            comerFacturaActa: datosRespuesta.data.resultComer,
                            concesionFacturaActa: datosRespuesta.data.resultConcesion,
                            load: ''
                        });
                    })
                .catch(console.log);
                authAxios.get("actas_interventoria/fact_operador/" + id_departamento + "/" + id_municipio + "/" + periodo_liquidacion)
                    .then((datosRespuesta) => {
                        console.log(datosRespuesta);
                        var status = datosRespuesta.data.status;
                        if (status) {
                            Swal.close();
                            Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                            window.localStorage.clear();
                            window.location.href = '/';
                        }
                        this.setState({
                            datosCargados: true,
                            periodo_liquidacion: periodo_liquidacion,
                            valor_facturado: datosRespuesta.data.resultOperador.VALOR_FACTURA,
                            valor_recaudo: datosRespuesta.data.resultOperador.VALOR_RECAUDO,
                            costo_energia: datosRespuesta.data.resultOperador.COSTO_ENERGIA,
                            traslado_neto: datosRespuesta.data.resultOperador.VALOR_FAVOR,
                            load: ''
                        });
                    })
                    .catch(console.log);
            })
            .catch(console.log);
        authAxios.get("actas_interventoria/periodos_fact")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, periodosActa: datosRespuesta.data, periodosLiquidacion: datosRespuesta.data, load: '' });
            })
            .catch(console.log);
        authAxios.get("departamentos_visitas/index/0")
            .then((datosRespuesta) => {
                console.log(datosRespuesta);
                var status = datosRespuesta.data.status;
                if (status) {
                    Swal.close();
                    Swal.fire('Token ha Expirado!', 'Vuelva a Iniciar Sesión', 'info');
                    window.localStorage.clear();
                    window.location.href = '/';
                }
                this.setState({ datosCargados: true, departamentosActa: datosRespuesta.data.data, load: '' });
                this.cargarMunicipios();
            })
            .catch(console.log);
    }
    render() {
        const { load, periodo_acta, periodo_liquidacion, valor_facturado, valor_recaudo, costo_energia,
                otras_deducciones, traslado_neto, actaInterventoria, periodosActa, periodosLiquidacion,
                departamentosActa, municipiosActa, aportesFacturaActa, municipioFacturaActa,
                comerFacturaActa, concesionFacturaActa
            } = this.state;
        return (
            <>
                <div className="content-wrapper">
                    <div className="content">
                        <div className="container-fluid">
                            <br />
                            <div className="card">
                                <div className="card-header text-center">
                                    {load ? (<b>{load}</b>) : (<b>EDITAR ACTA INTERVENTORÍA</b>)}
                                </div>
                                <div className="card-body">
                                    <form onSubmit={this.enviarDatos} id="form">
                                        <div className="row">
                                            <div className="col-xl-12">
                                                <div className='row g-3'>
                                                    <div className="col-md-2">
                                                        <input type="hidden" name="id_acta_interventoria" value={this.props.match.params.id} />
                                                        <input type="hidden" name="id_usuario" id="id_usuario" value={window.localStorage.getItem('idusuario')} />
                                                        <label htmlFor="fecha_acta">Fecha Acta</label>
                                                        <div className="input-group input-group-sm">
                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faCalendarAlt} /></span>
                                                            <input style={{ textTransform: 'uppercase' }} type="date" name="fecha_acta" id="fecha_acta" defaultValue={actaInterventoria.FECHA_ACTA}
                                                                className={((this.verificarError("error_fecha_acta")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Fecha Acta" aria-describedby="helpId"
                                                                onChange={this.cambioValor}
                                                            />
                                                        </div>
                                                        <small id="helpId" className="invalid-feedback">Seleccione la Fecha Acta</small>
                                                    </div>
                                                    <div className="col-md-2"></div>
                                                    <div className="col-md-2"></div>
                                                    <div className="col-md-2"></div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="id_periodo_acta">Periodo Acta</label>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="id_periodo_acta" id="id_periodo_acta" defaultValue={periodo_acta} 
                                                            className={((this.verificarError("error_id_periodo_acta")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="PERIODO ACTA" aria-describedby="helpId"
                                                            onChange={this.cambioValor} readOnly
                                                        />
                                                    </div>
                                                    <div className="col-md-2">
                                                        <label htmlFor="id_periodo_liquidacion">Periodo Liquidación</label>
                                                        <input style={{ textTransform: 'uppercase' }} type="text" name="id_periodo_liquidacion" id="id_periodo_liquidacion" defaultValue={periodo_liquidacion} 
                                                            className={((this.verificarError("error_id_periodo_liquidacion")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="PERIODO LIQUIDACIÓN" aria-describedby="helpId"
                                                            onChange={this.cambioValor} readOnly
                                                        />
                                                    </div>
                                                </div>
                                                <hr style={{ marginBottom: 0 }} />
                                                    <div style={{ fontSize: 14 }} className="card-header text-center">
                                                        <b>INFORMACIÓN DPTO. / MUNICIPIO</b>
                                                    </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className="col-md-3">
                                                        <label htmlFor="ID_COD_DPTO">Departamento</label>
                                                        <select name="ID_COD_DPTO"
                                                            id="ID_COD_DPTO"
                                                            value={actaInterventoria.ID_COD_DPTO}
                                                            options={actaInterventoria.ID_COD_DPTO}
                                                            onChange={e => {
                                                                this.cargarMunicipios(e);
                                                                this.cambioValor(e)
                                                            }}
                                                            className={((this.verificarError("error_id_departamento")) ? "is-invalid" : "") + " form-select form-select-sm"}>
                                                            <option value="">Seleccione el Departamento</option>
                                                            {
                                                                departamentosActa.map((itemDepartamentosActa) => (
                                                                    <option key={itemDepartamentosActa.ID_TABLA} value={itemDepartamentosActa.ID_DEPARTAMENTO}>{itemDepartamentosActa.NOMBRE}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Departamento</small>
                                                    </div>
                                                    <div className="col-md-3">
                                                        <label htmlFor="ID_COD_MPIO">Municipio</label>
                                                        <select name="ID_COD_MPIO"
                                                            id="ID_COD_MPIO"
                                                            value={actaInterventoria.ID_COD_MPIO}
                                                            options={actaInterventoria.ID_COD_MPIO}
                                                            className={((this.verificarError("error_id_municipio")) ? "is-invalid" : "") + " form-select form-select-sm"}
                                                            onChange={(e) => {
                                                                this.cambioValor(e);
                                                            }}>
                                                            <option value="">Seleccione el Municipio</option>
                                                            {
                                                                municipiosActa.map((itemMunicipiosActa) => (
                                                                    <option key={itemMunicipiosActa.ID_TABLA} value={itemMunicipiosActa.ID_MUNICIPIO}>{itemMunicipiosActa.NOMBRE}</option>
                                                                ))
                                                            }
                                                        </select>
                                                        <small id="helpId" className="invalid-feedback">Seleccione el Municipio</small>
                                                    </div>
                                                    <div className='col-md-2'></div>
                                                    <div className='col-md-2'>
                                                        <label htmlFor="periodo_acta">Periodo Actas</label><br />
                                                        <input type="hidden" id='periodo_acta' name='periodo_acta' defaultValue={actaInterventoria.PERIODO_ACTA} />
                                                        <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#PeriodosActaModal" slot='end'>
                                                            <FontAwesomeIcon icon={faCalendarCheck} />
                                                        </button>
                                                    </div>
                                                    <div className='col-md-2'>
                                                        <label htmlFor="periodo_liquidacion">Periodo Liquidación</label><br />
                                                        <input type="hidden" id='periodo_liquidacion' name='periodo_liquidacion' defaultValue={actaInterventoria.PERIODO_LIQUIDACION} />
                                                        <button type="button" className="btn btn-primary btn-sm" data-bs-toggle='modal' data-bs-target="#PeriodosLiquidacionModal" slot='end'>
                                                            <FontAwesomeIcon icon={faCalendarCheck} />
                                                        </button>
                                                    </div>
                                                </div>
                                                <hr style={{ marginBottom: 0 }} />
                                                <div style={{ fontSize: 14 }} className="card-header text-center">
                                                    <b>LIQUIDACIÓN OPERADORES DE RED</b>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className='col-md-12'>
                                                        <table className="table table-hover table-condensed table-sm">
                                                            <thead className="thead-inverse">
                                                                <tr>
                                                                    <th className="align-middle">VALOR FACTURADO</th>
                                                                    <th className="align-middle">VALOR RECAUDO</th>
                                                                    <th className="align-middle">COSTO ENERGÍA</th>
                                                                    <th className="align-middle">OTRAS DEDUCCIONES</th>
                                                                    <th className="align-middle">TRASLADO NETO</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                <tr>
                                                                    <td>
                                                                        <div className="input-group input-group-sm">
                                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="valor_facturado" id="valor_facturado" defaultValue={valor_facturado}
                                                                                className={((this.verificarError("error_valor_facturado")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Facturado" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="input-group input-group-sm">
                                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="valor_recaudo" id="valor_recaudo" defaultValue={valor_recaudo}
                                                                                className={((this.verificarError("error_valor_recaudo")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Valor Recaudo" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="input-group input-group-sm">
                                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="costo_energia" id="costo_energia" defaultValue={costo_energia}
                                                                                className={((this.verificarError("error_costo_energia")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Costo Energía" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="input-group input-group-sm">
                                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="otras_deducciones" id="otras_deducciones" defaultValue={otras_deducciones}
                                                                                className={((this.verificarError("error_otras_deducciones")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Otras Deducciones" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                    <td>
                                                                        <div className="input-group input-group-sm">
                                                                            <span className="input-group-text" id="inputGroupPrepend"><FontAwesomeIcon icon={faDollarSign} /></span>
                                                                            <input style={{ textTransform: 'uppercase' }} type="text" name="traslado_neto" id="traslado_neto" defaultValue={traslado_neto}
                                                                                className={((this.verificarError("error_traslado_neto")) ? "is-invalid" : "") + " form-control form-control-sm"} placeholder="Traslado Neto" aria-describedby="helpId"
                                                                                onChange={this.cambioValor}
                                                                            />
                                                                        </div>
                                                                    </td>
                                                                </tr>
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <hr style={{ marginBottom: 0 }} />
                                                <div style={{ fontSize: 14 }} className="card-header text-center">
                                                    <b>FACTURACIÓN OTROS AGENTES DE RECAUDO</b>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className='col-md-12'>
                                                        <table className="table table-hover table-condensed table-sm">
                                                            <thead className="thead-inverse">
                                                                <tr>
                                                                    <th className="align-middle">FUENTE DEL RECAUDO</th>
                                                                    <th className="align-middle">VALOR TRASLADO</th>
                                                                    <th className="align-middle">AGENTE RECAUDADOR</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    aportesFacturaActa.map((itemAportesFacturaActa, INDEX) => (
                                                                        <tr key={INDEX}>
                                                                            <td>MUNICIPIO</td>
                                                                            <td><b>$ </b>{currencyFormat(itemAportesFacturaActa.VALOR_RECAUDO)}</td>
                                                                            <td>MUNICIPIO</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                                {
                                                                    municipioFacturaActa.map((itemMunicipioFacturaActa, INDEX) => (
                                                                        <tr key={INDEX}>
                                                                            <td>{itemMunicipioFacturaActa.NOMBRE}</td>
                                                                            <td><b>$ </b>{currencyFormat(itemMunicipioFacturaActa.VALOR_RECAUDO)}</td>
                                                                            <td>MUNICIPIO</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                                {
                                                                    comerFacturaActa.map((itemComerFacturaActa, INDEX) => (
                                                                        <tr key={INDEX}>
                                                                            <td>{itemComerFacturaActa.NOMBRE}</td>
                                                                            <td><b>$ </b>{currencyFormat(itemComerFacturaActa.VALOR_RECAUDO)}</td>
                                                                            <td>COMERCIALIZADORA</td>
                                                                        </tr>
                                                                        ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                                <hr style={{ marginBottom: 0 }} />
                                                <div style={{ fontSize: 14 }} className="card-header text-center">
                                                    <b>FACTURA REALIZADA POR EL CONCESIONARIO</b>
                                                </div>
                                                <div style={{ marginTop: 0 }} className='row g-3'>
                                                    <div className='col-md-12'>
                                                        <table className="table table-hover table-condensed table-sm">
                                                            <thead className="thead-inverse">
                                                                <tr>
                                                                    <th className="align-middle">NO. FACTURA</th>
                                                                    <th className="align-middle">FECHA FACTURA</th>
                                                                    <th className="align-middle">CONCEPTO</th>
                                                                    <th className="align-middle">PERIODO</th>
                                                                    <th className="align-middle">TOTAL</th>
                                                                </tr>
                                                            </thead>
                                                            <tbody>
                                                                {
                                                                    concesionFacturaActa.map((itemConcesionFacturaActa, INDEX) => (
                                                                        <tr key={INDEX}>
                                                                            <td>{itemConcesionFacturaActa.NO_FACTURA}</td>
                                                                            <td>{itemConcesionFacturaActa.FECHA_FACTURA}</td>
                                                                            <td>{itemConcesionFacturaActa.NOMBRE}</td>
                                                                            <td>{itemConcesionFacturaActa.PERIODO}</td>
                                                                            <td><b>$ </b>{currencyFormat(itemConcesionFacturaActa.VALOR_BRUTO)}</td>
                                                                        </tr>
                                                                    ))
                                                                }
                                                            </tbody>
                                                        </table>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <hr />
                                        <div className='row'>
                                            <div className='col-xl-12 text-center'>
                                                <div className="btn-group" role="group" aria-label="">
                                                    <button type="submit" className="btn btn-primary btn-sm"><FontAwesomeIcon icon={faEdit} />&nbsp;&nbsp;Editar Acta Interventoría</button>&nbsp;&nbsp;
                                                    <Link className="btn btn-danger btn-sm" to={"/MasterActasInterventoria"}><FontAwesomeIcon icon={faTimes} />&nbsp;&nbsp;Cancelar</Link>
                                                </div>
                                            </div>
                                        </div>
                                    </form>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="PeriodosActaModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PeriodosActaModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="PeriodosActaModalLabel">Periodos Acta</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">PERIODO</th>
                                                    <th className="align-middle">SELECCIONAR</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    periodosActa.map((itemPeriodosActa) => (
                                                        <tr key={itemPeriodosActa.ID_TABLA}>
                                                            <td>{itemPeriodosActa.PERIODO} - {itemPeriodosActa.ANO_FACTURA}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        data-bs-dismiss="modal"
                                                                        onClick={() =>
                                                                            this.seleccionarPeriodo('ACTA', itemPeriodosActa.ANO_FACTURA + itemPeriodosActa.MES_FACTURA)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="modal fade" id="PeriodosLiquidacionModal" data-bs-backdrop="static" data-bs-keyboard="false" aria-labelledby="PeriodosLiquidacionModalLabel" aria-hidden="true">
                    <div className="modal-dialog" role="document">
                        <div className="modal-content">
                            <div className="modal-header">
                                <h4 className="modal-title w-100 text-center" id="PeriodosLiquidacionModalLabel">Periodos Liquidación</h4>
                                <button type="button" className="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                            </div>
                            <div className="modal-body">
                                <div className='row'>
                                    <div className='col-xl-12'>
                                        <table className="table table-hover table-condensed table-sm">
                                            <thead className="thead-inverse">
                                                <tr>
                                                    <th className="align-middle">PERIODO</th>
                                                    <th className="align-middle">SELECCIONAR</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {
                                                    periodosLiquidacion.map((itemPeriodosLiquidacion) => (
                                                        <tr key={itemPeriodosLiquidacion.ID_TABLA}>
                                                            <td>{itemPeriodosLiquidacion.PERIODO} - {itemPeriodosLiquidacion.ANO_FACTURA}</td>
                                                            <td>
                                                                <div className="btn-group" role="group" aria-label="">
                                                                    <button
                                                                        type="button"
                                                                        className="btn btn-primary btn-sm"
                                                                        data-bs-dismiss="modal"
                                                                        onClick={() =>
                                                                            this.seleccionarPeriodo('LIQUIDACION', itemPeriodosLiquidacion.ANO_FACTURA + itemPeriodosLiquidacion.MES_FACTURA)
                                                                        }
                                                                    >
                                                                        <FontAwesomeIcon icon={faArrowRight} />
                                                                    </button>
                                                                </div>
                                                            </td>
                                                        </tr>
                                                    ))
                                                }
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </>
        );
    }
}

export default Editar;